import {omneticApi} from '@dms/api/base';
import {BaseVoidRequestSchema} from '@dms/api/shared';

import {
  ApplyAiVehicleServiceIntervalApiArg,
  ApplyAiVehicleServiceIntervalApiArgSchema,
  ApplyAiVehicleServiceIntervalApiResponse,
  ApplyAiVehicleServiceIntervalApiResponseSchema,
  GenerateAiVehicleServiceIntervalsApiArg,
  GenerateAiVehicleServiceIntervalsApiArgSchema,
  GenerateAiVehicleServiceIntervalsApiResponse,
  GenerateAiVehicleServiceIntervalsApiResponseSchema,
  GetLatestAiVehicleServiceIntervalsApiArg,
  GetLatestAiVehicleServiceIntervalsApiResponse,
  GetLatestAiVehicleServiceIntervalsApiResponseSchema,
} from './types';

export const aiVehicleServiceIntervalsApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    generateAiVehicleServiceIntervals: build.mutation<
      GenerateAiVehicleServiceIntervalsApiResponse,
      GenerateAiVehicleServiceIntervalsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/ai-service-intervals`,
        method: 'POST',
        body: queryArg.body,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'AiVehicleServiceIntervals', id: `vehicle-${queryArg.vehicleId}`},
      ],
      extraOptions: {
        requestSchema: GenerateAiVehicleServiceIntervalsApiArgSchema,
        responseSchema: GenerateAiVehicleServiceIntervalsApiResponseSchema,
      },
    }),
    getLatestAiVehicleServiceIntervals: build.query<
      GetLatestAiVehicleServiceIntervalsApiResponse,
      GetLatestAiVehicleServiceIntervalsApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/ai-service-intervals/latest`,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'AiVehicleServiceIntervals', id: `vehicle-${queryArg.vehicleId}`},
      ],
      extraOptions: {
        responseSchema: GetLatestAiVehicleServiceIntervalsApiResponseSchema,
        requestSchema: BaseVoidRequestSchema,
      },
    }),
    applyAiVehicleServiceInterval: build.mutation<
      ApplyAiVehicleServiceIntervalApiResponse,
      ApplyAiVehicleServiceIntervalApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/ai-service-intervals/${queryArg.aiVehicleServiceIntervalId}/apply`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'Vehicle', id: queryArg.vehicleId},
        {type: 'AiVehicleServiceIntervals', id: `vehicle-${queryArg.vehicleId}`},
      ],
      extraOptions: {
        responseSchema: ApplyAiVehicleServiceIntervalApiResponseSchema,
        requestSchema: ApplyAiVehicleServiceIntervalApiArgSchema,
      },
    }),
  }),
});

export const {
  useGenerateAiVehicleServiceIntervalsMutation,
  useGetLatestAiVehicleServiceIntervalsQuery,
  useApplyAiVehicleServiceIntervalMutation,
} = aiVehicleServiceIntervalsApi;
